// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__QM7OY","overflowing":"ReadFullNote_overflowing__2tri-"};